// What the GitLab API returned on 2026-10-29. Shown when the live API cannot be
// reached (visitor offline, GitLab down); replaced by live data otherwise.
const SNAPSHOT = {
    takenAt: '2026-10-29',
    project: {
        name: 'vlm-page-recognition',
        description: null,
        star_count: 0,
        forks_count: 0,
        default_branch: 'main',
        last_activity_at: '2026-10-28T07:56:38.507Z',
    },
    commit: {
        short_id: '098df022',
        title: 'MCP 加探索：页面地图（explore）和骨架方法（site_add_widgets）；方法分计划中 / 已实现 / 已验证；台架上探出 9 页、生成 102 个骨架方法',
        committed_date: '2026-10-28T15:47:01.000+08:00',
    },
    tree: [
        ['archive', 'tree'], ['docs', 'tree'], ['mcp_test', 'tree'], ['results', 'tree'],
        ['screen_inspector', 'tree'], ['screenshots', 'tree'], ['targets', 'tree'], ['tests', 'tree'],
        ['.gitattributes', 'blob'], ['.gitignore', 'blob'], ['CHANGELOG.md', 'blob'], ['MANIFEST.in', 'blob'],
        ['README.md', 'blob'], ['pyproject.toml', 'blob'], ['requirements.txt', 'blob'],
    ].map(([name, type]) => ({ name, type, path: name })),
    release: {
        tag_name: 'v0.1.0',
        name: 'screen-inspector 0.1.0',
        released_at: '2026-10-28T05:30:58.000Z',
        author: { name: 'Yuwen Lu' },
        commit: { short_id: '767ce282' },
        assets: {
            sources: ['zip', 'tar.gz'].map((format) => ({
                format,
                url: `https://gitlab.meetyuwen.com/testing/vlm-page-recognition/-/archive/v0.1.0/vlm-page-recognition-v0.1.0.${format}`,
            })),
        },
        description: [
            '第一个发布版本。',
            '',
            '### 函数库（`pip install screen-inspector`）',
            '',
            '- **识别**：`ScreenInspector` 的 `choose`（选择题）、`check`（判断题）、`read` / `read_number`（读文字 / 读数）、 `choose_image`（图片选择题，`pixels_first=True` 先比像素）、`inspect_page`（页面状态树）。模型是本机 Ollama 上的 qwen3-vl:4b。',
            '- **定位**：`locate` / `match_template`（模板匹配）；对象库 `TargetLibrary`（SQLite / YAML 存储），条目用 anchor 只匹配不随状态变的部分。',
            '- **操作画面**：`Hmi`（在截图上找条目、点击、逐字符输入、`wait_for` / `wait_gone` / `wait_until`）、 `Screen` 接口（画面来源由测试项目实现）、`ImageScreen`（存好的截图当画面）。',
            '- **页面类**：`Page`、`value_of`（模型没给出能用的答案时抛 `ReadError`）。',
            '- **判断记录**：每次判断记进本机的记录库，`dashboard=True` 打开记录网页。',
            '',
            '### MCP 服务器（`pip install "screen-inspector[mcp]"`，命令 `screen-inspector-mcp`）',
            '',
            '- 查对象库、看截图、建条目、试问法（`try_question`）；**试通门槛**：全对、期望答案至少两种才算试通。',
            '- 产出页面类方法（`--tests`）：`export_reading`（读数 / 判断，返回值、不带断言）、`export_action`（在设备上录的操作）、 `export_test`（只组合页面方法的用例，支持 `wait_s` 等生效、`record_cleanup` 收尾）；每个方法的说明里写着证据。',
            '- 操作真机（`--screen 文件.py:函数`）：`device_screenshot` / `device_click` / `device_type`（`env=` 从环境变量取密码）/ `device_call` 等。',
            '- MCP Python SDK 2.x（兼容 1.x 导入）。',
            '',
            '### 安装',
            '',
            '先装 [Ollama](https://ollama.com)，下载模型：`ollama pull qwen3-vl:4b`。然后在虚拟环境里（Python 3.10+）选一种：',
            '',
            '```bash',
            '# 有这个仓库读权限的：直接从 GitLab 装',
            'pip install "screen-inspector[mcp] @ git+https://gitlab.meetyuwen.com/testing/vlm-page-recognition.git@v0.1.0"',
            '',
            '# 下载下面的发布包 screen-inspector-0.1.0.zip，解压后装里面的安装包',
            'pip install "screen_inspector-0.1.0-py3-none-any.whl[mcp]"',
            '```',
            '',
            '只用函数库、不用 MCP 的，去掉 `[mcp]`。MCP 怎么接到 Claude Code 见 [README 的“安装”](https://gitlab.meetyuwen.com/testing/vlm-page-recognition/-/blob/v0.1.0/README.md#%E5%AE%89%E8%A3%85)。',
            '',
            '### 发布包 [screen-inspector-0.1.0.zip](/uploads/5ae59adc9048e0bfe9cbef63b5134417/screen-inspector-0.1.0.zip)',
            '',
            '安装包（`.whl`）和源码包、`先读我.md`、README、CHANGELOG、`docs/`（函数库文档、用 MCP 写测试的场景和提示词、给 AI 的说明书）、`examples/webrh.py`（西门子 WinCC Unified Web RH 的画面来源例子）。',
        ].join('\n'),
    },
};

export default SNAPSHOT;
